import api from "./api";
import type { ILogsCartaoResponse } from "interfaces/logsCartao";

/** GET /admin/logs/cartao */
export async function getLogsCartao() {
  const { data, status } = await api.get<ILogsCartaoResponse>("/admin/logs/cartao");
  return { data, status } as { data: ILogsCartaoResponse; status: number };
}
